import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import AccountConstants from '../constants/AccountConstants';
import SavingsPotsConstants from '../constants/SavingsPotsConstants';
import SavingsPotsUtils from '../utils/SavingsPotsUtils';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';
import _ from 'lodash';

let _collectAccountID = [];
let _potData = [];
let _accountData = [];
let _checkpotFlag = false;
let _accountList = [];
let _accountID;
let _getCreateSavingPotPage = false;
let _getCreatedPotData;
let _getPotDetailsPage = false;
let _potDetailData = null;
let _reducePotData = [];
let _getPotId;
let _getEditedPotData;
let _getEditedPotID;
let _potConfirmationFlag = false;
let _accountIndex;
let _displayLoading = false;
let _editError = {};
let _potError = {};
let _unavailableCheck = false;
let _interPotError = {};
let _createPotData = {};
let _isNetworkError = false;
let _checkActiveFlag = false;
let _rejigDoneFlag = false;
let _checkCurrentAccFlag;
let _navigationReference;
let potBalanceValue;

const defaultError = {
  error: {
    code: 500,
    developer_message: null,
    id: null,
    message: 'Something techie has gone wrong',
    quoteId: null,
  },
};

const SavingsPotsStore = Object.assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
   * @param {function} callback
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
   * Allow views to unbind listeners before dismounting.
   *
   * @param  {Function} callback    Function to unbind.
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },
  // to get all acoount list
  checkpotFlag() {
    return _checkpotFlag;
  },
  getPotData() {
    return _potData || [];
  },
  setPotBalanceStoreValue(value) {
    potBalanceValue = value;
  },
  getPotBalanceStoreValue() {
    return potBalanceValue;
  },
  getCreateSavingPotPage() {
    return _getCreateSavingPotPage;
  },
  getPotDetailsFlag() {
    return _getPotDetailsPage;
  },
  getPotDetailsData() {
    return _potDetailData;
  },
  getReducePotPage() {
    return _reducePotData;
  },

  getPotConfirmationFlag() {
    return _potConfirmationFlag;
  },
  getClickedAccount() {
    return _accountData;
  },
  getSelectedAccountID() {
    return _accountID;
  },
  getCreatedPotData() {
    return _getCreatedPotData;
  },
  getAccountIndex() {
    return _accountIndex;
  },
  getMoveMoneyAccountIndex(accID) {
    const acc = [];
    if (accID !== undefined) {
      _.map(_accountList, (account, i) => {
        if (account.id === accID) {
          _accountIndex = (i % 10) + 1;
          _accountID = account.id;
        }
      });
    } else {
      _.map(_accountList, (account, i) => {
        if (account.actionsAvailable['/account/pots']) {
          acc.push((i % 10) + 1);
          _collectAccountID.push(account.id);
        }
      });
      _accountIndex = _.head(acc);
      _accountID = _.toString(_.head(_collectAccountID));
    }
    if (_accountID !== '') {
      SavingsPotsUtils.getPotsData(_accountID, true);
    }
  },
  editError() {
    return _editError || {};
  },
  potError() {
    return _potError || {};
  },
  unavailableCheck() {
    return _unavailableCheck;
  },
  interPotError() {
    return _interPotError;
  },
  displayLoading() {
    return _displayLoading;
  },
  createPotData() {
    return _createPotData;
  },
  isNetworkError() {
    return _isNetworkError;
  },
  checkActiveFlag() {
    return _checkActiveFlag;
  },
  setCheckActiveFlag(flag) {
    _checkActiveFlag = flag;
    this.emitChange();
  },
  rejigDoneFlag() {
    return _rejigDoneFlag;
  },
  getCurrentAccountFlag() {
    let savingAccCount = 0;
    _.map(_accountList, (account, i) => {
      if (account.actionsAvailable['/account/pots']) {
        savingAccCount++;
      }
    });
    if (savingAccCount > 0) {
      _checkCurrentAccFlag = false;
    } else {
      _checkCurrentAccFlag = true;
    }
    return _checkCurrentAccFlag;
  },
  getNavigationReference() {
    return _navigationReference;
  },
  resetStore() {
    _collectAccountID = [];
    _potData = [];
    _accountData = [];
    _checkpotFlag = false;
    _accountList = [];
    _accountID = '';
    _getCreateSavingPotPage = false;
    _getCreatedPotData = '';
    _getPotDetailsPage = false;
    _potDetailData = null;
    _reducePotData = [];
    _getPotId = '';
    _getEditedPotData = '';
    _getEditedPotID = '';
    _potConfirmationFlag = false;
    _accountIndex = '';
    _displayLoading = false;
    _editError = {};
    _potError = {};
    _unavailableCheck = false;
    _interPotError = {};
    _createPotData = {};
    _isNetworkError = false;
    _checkActiveFlag = false;
    _rejigDoneFlag = false;
    _checkCurrentAccFlag = '';
    _navigationReference = '';
  },

  resetFlags() {
    _getCreateSavingPotPage = false;
    _potData = [];
    _reducePotData = [];
    _potDetailData = null;
    _getPotDetailsPage = false;
    _potConfirmationFlag = false;
  },
});

SavingsPotsStore.dispatchToken = AppDispatcher.register((payload) => {
  const action = payload.action;
  switch (action.actionType) {
    case SavingsPotsConstants.POT_NAVIGATION_REFERENCE:
      _navigationReference = action.data;
      break;
    case SavingsPotsConstants.REQUEST_POT_ACCOUNTS_LIST:
      _checkCurrentAccFlag = false;
      _checkActiveFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      SavingsPotsUtils.getAccountsList();
      break;
    case AccountConstants.REQUEST_ACCOUNTS_LIST_SUCCESS:
      _accountList = action.data;
      SavingsPotsStore.getMoveMoneyAccountIndex();
      break;
    case SavingsPotsConstants.REQUEST_POT_ACCOUNTS_LIST_ERROR:
      if (!action.data) {
        _isNetworkError = true;
      } else {
        _isNetworkError = false;
      }
      SavingsPotsStore.emitChange();
      break;

    case SavingsPotsConstants.REQUEST_POT_DATA:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _displayLoading = true;
      SavingsPotsUtils.getPotsData(_accountID);
      SavingsPotsStore.emitChange();
      break;

    case SavingsPotsConstants.REQUEST_POT_DATA_SUCCESS:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _getCreateSavingPotPage = false;
      _getPotDetailsPage = false;
      _potData = action.data;
      _potConfirmationFlag = false;
      _potDetailData = null;
      _reducePotData = [];
      _checkpotFlag = true;
      _displayLoading = false;
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_POT_DATA_SUCCESS_MOVEMONEY:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _potData = action.data;
      _potConfirmationFlag = false;
      _reducePotData = [];
      _checkpotFlag = true;
      _displayLoading = false;
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_POT_DATA_REJIG_SUCCESS:
      _.map(_accountList, (account, i) => {
        if (account.actionsAvailable['/account/pots']) {
          // acc.push((i % 10) + 1); todo find out whats going on with this line!
          _collectAccountID.push(account.id);
        }
      });
      _accountID = _.toString(_.head(_collectAccountID));
      if (_accountID !== '' && _accountID === action.data.id) {
        _potData = action.data.pots;
      }
      break;
    case SavingsPotsConstants.REQUEST_POT_DATA_ERROR:
      if (!action.data) {
        _isNetworkError = true;
        _displayLoading = false;
      } else {
        _isNetworkError = false;
        _potError = action.data;
        _unavailableCheck = true;
        _displayLoading = false;
      }
      SavingsPotsStore.emitChange();
      break;

    case SavingsPotsConstants.REQUEST_SELECTED_ACCOUNT:
      _checkActiveFlag = action.activeFlag;
      _isNetworkError = false;
      _potData = [];
      _accountData = action.data;
      _accountID = _accountData.id;
      _accountIndex = (action.index % 10) + 1;
      SavingsPotsUtils.getPotsData(_accountID);
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_CREATE_PAGE:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _getCreateSavingPotPage = true;
      _editError = {};
      _createPotData = {};
      _getPotDetailsPage = false;
      if (action.data !== undefined) {
        _potDetailData = action.data;
      }
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_POT_DETAIL_PAGE:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _getPotId = action.data;
      SavingsPotsUtils.getSinglePotData(_getPotId, _accountID);
      break;
    case SavingsPotsConstants.REQUEST_SINGLE_POT_DATA_SUCCESS:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _getCreateSavingPotPage = false;
      _getPotDetailsPage = true;
      _potDetailData = action.data;
      _displayLoading = false;
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_SINGLE_POT_DATA_ERROR:
      if (!action.data && action.status !== 500) {
        _isNetworkError = true;
      } else {
        let errorMessage;
        if (!action.data) {
          errorMessage = defaultError;
        } else {
          errorMessage = action.data;
        }
        _isNetworkError = false;
        _editError = errorMessage;
        _displayLoading = false;
      }
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_REDUCE_POT_PAGE:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _getCreateSavingPotPage = false;
      _reducePotData = action.data;
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_NEW_POT_CONFIRMATION:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _displayLoading = true;
      _editError = {};
      _createPotData = action.data;
      SavingsPotsUtils.getCreatePotData(action.data, _accountID);
      break;
    case SavingsPotsConstants.REQUEST_CREATED_POT_DATA_SUCCESS:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _getCreatedPotData = action.data;
      _getCreateSavingPotPage = false;
      _potConfirmationFlag = true;
      _getPotDetailsPage = false;
      _potDetailData = null;
      _displayLoading = false;
      _editError = {};
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_CREATED_POT_DATA_ERROR:
      if (!action.data && action.status !== 500) {
        _isNetworkError = true;
      } else {
        let errorMessage;
        if (!action.data) {
          errorMessage = defaultError;
        } else {
          errorMessage = action.data;
        }
        _isNetworkError = false;
        _editError = errorMessage;
        _displayLoading = false;
      }
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_POT_DETAIL_DATA_ERROR:
      if (!action.data) {
        _isNetworkError = true;
      } else {
        _isNetworkError = false;
      }
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_DELETE_POT_CONNECTION:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _displayLoading = true;
      _getPotId = action.data;
      SavingsPotsUtils.deletePotConnection(_getPotId, _accountID);
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_EDITED_POT_DATA:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _getEditedPotData = action.data;
      _getEditedPotID = action.id;
      _displayLoading = true;
      SavingsPotsUtils.editPotConnection(
        _getEditedPotID,
        _accountID,
        _getEditedPotData
      );
      break;
    case SavingsPotsConstants.REQUEST_INTERPOT_DATA:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _interPotError = {};
      _potData = [];
      _rejigDoneFlag = true;
      SavingsPotsUtils.getInterPotData(action.data, _accountID);
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_INTERPOT_DATA_SUCCESS:
      _checkCurrentAccFlag = false;
      _unavailableCheck = false;
      _isNetworkError = false;
      _interPotError = {};
      _.map(_accountList, (account, i) => {
        if (account.id === _accountID) {
          _accountIndex = (i % 10) + 1;
        }
      });
      _reducePotData = [];
      SavingsPotsUtils.getPotsData(_accountID);
      _rejigDoneFlag = false;
      break;
    case SavingsPotsConstants.REQUEST_INTERPOT_DATA_ERROR:
      if (!action.data) {
        _isNetworkError = true;
      } else {
        _isNetworkError = false;
        _interPotError = action.data;
      }
      SavingsPotsStore.emitChange();
      break;
    case SavingsPotsConstants.REQUEST_CLOSE_ERROR_MODAL:
      if (_isNetworkError) {
        SavingsPotsUtils.getAccountsList();
        _isNetworkError = false;
      }
      _interPotError = {};
      _editError = {};
      _potError = {};
      SavingsPotsStore.emitChange();
      break;
    case AppConstants.LOGOUT_USER:
      SavingsPotsStore.resetStore();
      SavingsPotsStore.emitChange();
      break;
    default: {
      break;
    }
  }
});

export default SavingsPotsStore;
